import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { RecordProps } from "./types";

const Record: React.FC<RecordProps> = ({ refreshTrigger }) => {
  const { id } = useParams<{ id: string }>();
  const token = localStorage.getItem("token");

  const [recordDetail, setRecordDetail] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch(`https://has-backend-c48d669d897f.herokuapp.com/admin/record/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Error HTTP! Estado: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        setRecordDetail(data);
        setIsLoading(false);
        console.log(data.canSeeGuide)
      })
      .catch((error) => {
        console.error("Error al cargar detalles del expediente:", error);
        setIsLoading(false);
      });

  }, [id, refreshTrigger]);

  return (
    <div className="w-full flex flex-col items-center justify-center">
      {recordDetail && recordDetail.userId ? (
        <div className="w-[95%] md:w-2/3 bg-[#f8f8f8] rounded-md shadow-lg font-sourceSans flex flex-col gap-8 pt-8 px-4 md:px-8 pb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex flex-col gap-4 items-start">
              <div>
                <p className="font-semibold">Nombre Completo</p>
                <p className="bg-[#EFEFEF] rounded-md pl-2 pr-4 py-1 break-words">{recordDetail.userId.name}</p>
              </div>
              <div>
                <p className="font-semibold">Correo electrónico</p>
                <p className="bg-[#EFEFEF] rounded-md pl-2 pr-4 py-1 break-words">{recordDetail.userId.email}</p>
              </div>
              <div>
                <p className="font-semibold">Número de teléfono</p>
                <p className="bg-[#EFEFEF] rounded-md pl-2 pr-4 py-1 break-words">{recordDetail.phoneNumber}</p>
              </div>
              <div>
                <p className="font-semibold">Monto a pagar</p>
                <p className="bg-[#EFEFEF] rounded-md pl-2 pr-4 py-1 break-words">{recordDetail.userId.modulePrice}</p>
              </div>
            </div>
            <div>
              <p className="font-semibold">Guia Digital</p>
              <p className="bg-[#EFEFEF] rounded-md pl-2 pr-4 py-1 break-words">{recordDetail.canSeeGuide === true ? "Plan digital" : "Plan fisico" }</p>
            </div>
            <div className="flex flex-col gap-4">
              <div>
                <p className="font-semibold">Dirección</p>
                <p className="bg-[#EFEFEF] rounded-md pl-2 pr-4 py-1 break-words">{recordDetail.address}</p>
              </div>
              <div>
                <p className="font-semibold">Quien vendió</p>
                <p className="bg-[#EFEFEF] rounded-md pl-2 pr-4 py-1 break-words">{recordDetail.whoSold}</p>
              </div>
              <div>
                <p className="font-semibold">Patrocinador</p>
                <p className="bg-[#EFEFEF] rounded-md pl-2 pr-4 py-1 break-words">{recordDetail.sponsor}</p>
              </div>
              <div>
                <p className="font-semibold">Fecha de inicio</p>
                <p className="bg-[#EFEFEF] rounded-md pl-2 pr-4 py-1 break-words">{recordDetail.startDate}</p>
              </div>
              <div>
                <p className="font-semibold">Contraseña</p>
                <p className="bg-[#EFEFEF] rounded-md pl-2 pr-4 py-1 break-words">{recordDetail.userId.password}</p>
              </div>
            </div>
          </div>

          {/* Archivos */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-6">
            {['ine', 'curpImage', 'birthCertificate', 'highSchoolCertificate', 'welcomeLetter'].map((key) => {
              const file = recordDetail?.documents?.[key];
              if (!file) return null;

              const fileNameMap: Record<string, string> = {
                ine: "INE",
                curpImage: "CURP",
                birthCertificate: "Acta de Nacimiento",
                highSchoolCertificate: "Certificado de Secundaria",
                welcomeLetter: "Carta de Bienvenida",
              };

              const fileUrl = `https://guiascontainer.s3.us-east-2.amazonaws.com/${file}`;
              const isPdf = file.endsWith(".pdf");

              return (
                <div key={key}>
                  <p className="font-semibold mb-2">{fileNameMap[key]}</p>
                  {isPdf ? (
                    <iframe
                      src={fileUrl}
                      className="w-full h-64 rounded border"
                      title={key}
                    />
                  ) : (
                    <img
                      src={fileUrl}
                      alt={key}
                      className="w-full h-64 object-contain rounded border"
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <p className="font-sourceSans text-center mt-6">El usuario aún no tiene expediente</p>
      )}
    </div>
  );
};

export default Record;
